/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export type ChartConfigType = 'chartjs' | 'plotly' | 'unknown';

export class ChartConfigDetector {
    public static detect(value: unknown): ChartConfigType {
        if (this.isChartJs(value)) {
            return 'chartjs';
        }

        if (this.isPlotly(value)) {
            return 'plotly';
        }

        return 'unknown';
    }

    public static isChartJs(value: unknown): boolean {
        return this.isRecord(value)
            && this.isRecord(value.data)
            && Array.isArray(value.data.datasets);
    }

    public static isPlotly(value: unknown): boolean {
        return this.isRecord(value) && Array.isArray(value.data);
    }

    private static isRecord(value: unknown): value is Record<string, unknown> {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
}
